import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const path = "restaurant/theme-customizer";
const options = {role: ROLE.RESTAURANT};


export const themeCustomizerUpadte = async (values) => {
  return await axiosInstance(options).post(`${path}/configure-theme-customizer`, values);
}

export const getThemeCustomizerUpdate = async () => {
    return await axiosInstance(options).post(`${path}/get-theme-customizer`, {});
}